<template>
  <div class="mappingmaster-layout">
    <div class="header">
      <nav class="navbar navbar-expand-lg navbar-light bg-white">
        <router-link :to="{name: 'login'}" class="navbar-brand">
          <icon class="icon d-inline-block align-top"
                width="184"
                height="30"
                path="mappingmaster"
                type="mappingmaster-header-logo"/>
        </router-link>
        <button class="navbar-toggler" ref="sideBarButton" type="button" @click.prevent="toggleSideBar" >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" :class="{hidden: sideBarOpen}" v-show="sideBarOpen"
             v-closable="{exclude: ['sideBarButton'], handler: 'onCloseSideBar'}">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item dropdown mb-xl-2">
              <a class="nav-link dropdown-toggle" @click.prevent="toggleDropdownLanguage" href="#"
                 ref="languageDropdownButton">
                {{ lang.title }}
              </a>
              <div class="dropdown-menu" v-show="languageDropdownOpen"
                   v-closable="{exclude: ['languageDropdownButton'],handler: 'onCloseLanguageDropdown'}">
                <a class="dropdown-item" href="#" :class="{disabled : lang.code === code}"
                   v-for="({ code, title}) in langs"
                   :key="`lang-${code}`"
                   :disabled="lang.code === code"
                   @click.prevent="onChangeLanguage(code)">
                  {{ title }}
                </a>
              </div>
            </li>
          </ul>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"
                 href="#"
                 @click.prevent="toggleDropdownProducts"
                 ref="productsDropdownButton">
                {{ $t('mappingMaster.products') }}
              </a>
              <div class="dropdown-menu" v-show="productsDropdownOpen"
                   v-closable="{exclude: ['productsDropdownButton'],handler: 'onCloseProductsDropdown'}">
                <a class="dropdown-item"
                   href="https://www.mappingmaster.com/en/connections/property-management-systems/">
                  {{ $t('mappingMaster.mappingMasterChannelManager') }}
                </a>
                <a class="dropdown-item"
                   href="https://www.mappingmaster.com/en/products/mappingmaster-masterbookings/">
                  {{ $t('mappingMaster.mappingMasterMasterBooking') }}
                </a>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle"
                 href="#"
                 @click.prevent="toggleDropdownConnections"
                 data-toggle="dropdown"
                 ref="connectionsDropdownButton">
                {{ $t('mappingMaster.connections') }}
              </a>
              <div class="dropdown-menu" v-show="connectionsDropdownOpen"
                   v-closable="{exclude: ['connectionsDropdownButton'],handler: 'onCloseConnectionsDropdown'}">
                <a class="dropdown-item"
                   href="https://www.mappingmaster.com/en/connections/property-management-systems">
                  {{ $t('mappingMaster.propertyManagementSystems') }}
                </a>
                <a class="dropdown-item"
                   href="https://www.mappingmaster.com/en/connections/distribution-channels">
                  {{ $t('mappingMaster.distributionChannels') }}
                </a>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link"
                 href="https://www.mappingmaster.com/en/prices">
                {{ $t('mappingMaster.prices') }}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link"
                 href="https://www.mappingmaster.com/en/contact">
                {{ $t('mappingMaster.contact') }}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link"
                 href="https://www.mappingmaster.com/en/news">
                {{ $t('mappingMaster.news') }}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link"
                 href="https://www.mappingmaster.com/en/support">
                {{ $t('mappingMaster.support') }}
              </a>
            </li>
            <li class="nav-item sm-login-link">
              <router-link :to="{ name: 'login' }" class="nav-link">
                {{ $t('mappingMaster.login') }}
              </router-link>
            </li>
            <li class="nav-item login-link">
              <router-link :to="{ name: 'login' }" class="nav-link">
                {{ $t('mappingMaster.login') }}
              </router-link>
            </li>
          </ul>
        </div>
      </nav>
    </div>

    <div class="d-flex justify-content-center">
      <router-view />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapState } from 'vuex';
  // eslint-disable-next-line import/no-cycle
  import TranslationHelper from '@/helpers/translation.helper';
  // eslint-disable-next-line import/no-cycle
  import { router } from '@/router';
  import { Storage } from '@/services/storage.service';

  export default {
    name: 'MappingMasterLayout',
    data() {
      return {
        languageDropdownOpen: false,
        sideBarOpen: false,
        productsDropdownOpen: false,
        connectionsDropdownOpen: false,
        faviconPath: './mapping-master.ico',
      };
    },
    computed: {
      ...mapGetters('data', ['languages']),
      ...mapState('translation', ['translatedLanguages', 'translationPending']),
      ...mapGetters('user', ['lang']),

      langs() {
        if (this.translatedLanguages != null) {
          const result = this.languages.filter((lang) => this.translatedLanguages.some(
            (tansLang) => lang.code === tansLang,
          ));
          return result.map(({ nativeName, code }) => (
            {
              code,
              title: `${nativeName}`,
            }
          ));
        }
        return this.languages.map(({ nativeName, code }) => ({ code, title: `${nativeName}` }));
      },
    },
    methods: {
      ...mapMutations('user', ['setLang']),

      async onChangeLanguage(languageCode) {
        this.languageDropdownOpen = false;
        if (this.lang.code !== languageCode) {
          this.$store.commit('appLoading', true);
          this.setLang(languageCode);
          await TranslationHelper.updateTranslations(router, Storage.getLang(), true);
          this.$store.commit('appLoading', false);
        }
      },
      toggleSideBar() {
        this.sideBarOpen = !this.sideBarOpen;
      },
      toggleDropdownLanguage() {
        this.languageDropdownOpen = !this.languageDropdownOpen;
      },
      toggleDropdownProducts() {
        this.productsDropdownOpen = !this.productsDropdownOpen;
      },
      toggleDropdownConnections() {
        this.connectionsDropdownOpen = !this.connectionsDropdownOpen;
      },
      onCloseLanguageDropdown() {
        this.languageDropdownOpen = false;
      },
      onCloseProductsDropdown() {
        this.productsDropdownOpen = false;
      },
      onCloseConnectionsDropdown() {
        this.connectionsDropdownOpen = false;
      },
      onCloseSideBar() {
        this.sideBarOpen = false;
      },
    },
    async created() {
      document.body.style.setProperty(
        '--input-background-color',
        'rgba(255, 255, 255, 1)',
        'important',
      );
      document.body.style.setProperty(
        '--input-text-color',
        'rgba(30, 30, 30, 1)',
        'important',
      );
      this.updateAppFavicon();
      this.updateAppTitle();
    },
  };
</script>

<style scoped>

</style>
